var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewStars4Half(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 10,
    viewBox: "0 0 71 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 10,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property Detail - Pricng detail closed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3741,
    transform: "translate(-190 -2713)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000008602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000008601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 694_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.289533 4.51235L2.43393 5.9917C2.67895 6.16064 2.7816 6.46014 2.6882 6.73362L1.86863 9.12788C1.65954 9.73949 2.39666 10.2482 2.94491 9.87027L5.0893 8.3907C5.33432 8.22152 5.6658 8.22152 5.91082 8.3907L8.05521 9.87027C8.60322 10.2482 9.34058 9.73949 9.13149 9.12788L8.31229 6.73362C8.2184 6.46014 8.32105 6.16064 8.56632 5.9917L10.7105 4.51235C11.2582 4.13422 10.977 3.31123 10.2997 3.31123H7.64908C7.34634 3.31123 7.07733 3.12598 6.98405 2.8525L6.16509 0.45905C5.95576 -0.153017 5.04461 -0.153017 4.83503 0.45905L4.01558 2.85262C3.9223 3.1261 3.65427 3.31135 3.35104 3.31135H0.700291C0.0229605 3.31135 -0.258226 4.13434 0.289533 4.51235Z",
    fill: "#01152E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.2895 4.51235L17.4339 5.9917C17.6789 6.16064 17.7816 6.46014 17.6882 6.73362L16.8686 9.12788C16.6595 9.73949 17.3967 10.2482 17.9449 9.87027L20.0893 8.3907C20.3343 8.22152 20.6658 8.22152 20.9108 8.3907L23.0552 9.87027C23.6032 10.2482 24.3406 9.73949 24.1315 9.12788L23.3123 6.73362C23.2184 6.46014 23.3211 6.16064 23.5663 5.9917L25.7105 4.51235C26.2582 4.13422 25.977 3.31123 25.2997 3.31123H22.6491C22.3463 3.31123 22.0773 3.12598 21.9841 2.8525L21.1651 0.45905C20.9558 -0.153017 20.0446 -0.153017 19.835 0.45905L19.0156 2.85262C18.9223 3.1261 18.6543 3.31135 18.351 3.31135H15.7003C15.023 3.31135 14.7418 4.13434 15.2895 4.51235Z",
    fill: "#01152E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.2895 4.51235L32.4339 5.9917C32.6789 6.16064 32.7816 6.46014 32.6882 6.73362L31.8686 9.12788C31.6595 9.73949 32.3967 10.2482 32.9449 9.87027L35.0893 8.3907C35.3343 8.22152 35.6658 8.22152 35.9108 8.3907L38.0552 9.87027C38.6032 10.2482 39.3406 9.73949 39.1315 9.12788L38.3123 6.73362C38.2184 6.46014 38.3211 6.16064 38.5663 5.9917L40.7105 4.51235C41.2582 4.13422 40.977 3.31123 40.2997 3.31123H37.6491C37.3463 3.31123 37.0773 3.12598 36.9841 2.8525L36.1651 0.45905C35.9558 -0.153017 35.0446 -0.153017 34.835 0.45905L34.0156 2.85262C33.9223 3.1261 33.6543 3.31135 33.351 3.31135H30.7003C30.023 3.31135 29.7418 4.13434 30.2895 4.51235Z",
    fill: "#01152E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.2895 4.51235L47.4339 5.9917C47.6789 6.16064 47.7816 6.46014 47.6882 6.73362L46.8686 9.12788C46.6595 9.73949 47.3967 10.2482 47.9449 9.87027L50.0893 8.3907C50.3343 8.22152 50.6658 8.22152 50.9108 8.3907L53.0552 9.87027C53.6032 10.2482 54.3406 9.73949 54.1315 9.12788L53.3123 6.73362C53.2184 6.46014 53.3211 6.16064 53.5663 5.9917L55.7105 4.51235C56.2582 4.13422 55.977 3.31123 55.2997 3.31123H52.6491C52.3463 3.31123 52.0773 3.12598 51.9841 2.8525L51.1651 0.45905C50.9558 -0.153017 50.0446 -0.153017 49.835 0.45905L49.0156 2.85262C48.9223 3.1261 48.6543 3.31135 48.351 3.31135H45.7003C45.023 3.31135 44.7418 4.13434 45.2895 4.51235Z",
    fill: "#01152E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M60.2895 4.51235L62.4339 5.9917C62.6789 6.16064 62.7816 6.46014 62.6882 6.73362L61.8686 9.12788C61.6595 9.73949 62.3967 10.2482 62.9449 9.87027L65.0893 8.3907C65.3343 8.22152 65.6658 8.22152 65.9108 8.3907L68.0552 9.87027C68.6032 10.2482 69.3406 9.73949 69.1315 9.12788L68.3123 6.73362C68.2184 6.46014 68.3211 6.16064 68.5663 5.9917L70.7105 4.51235C71.2582 4.13422 70.977 3.31123 70.2997 3.31123H67.6491C67.3463 3.31123 67.0773 3.12598 66.9841 2.8525L66.1651 0.45905C65.9558 -0.153017 65.0446 -0.153017 64.835 0.45905L64.0156 2.85262C63.9223 3.1261 63.6543 3.31135 63.351 3.31135H60.7003C60.023 3.31135 59.7418 4.13434 60.2895 4.51235Z",
    fill: "#D6D6D6"
  })))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStars4Half);
export default __webpack_public_path__ + "static/media/review-stars-4half.36eba3b0f246e1b6ba6f02ab17cc4ae2.svg";
export { ForwardRef as ReactComponent };